import { useDeferredValue } from 'react'
import { useViewport } from '@xyflow/react'

export default function useZoomLevel() {
  const { zoom } = useViewport()
  return useDeferredValue(zoom)
}
